import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '../../services/admin/admin.service';
import { LayoutDashboard, Home, HelpCircle, BookOpen, BarChart3, Users, Loader2 } from 'lucide-react';

export default function AdminDashboardPage() {
    const [stats, setStats] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        adminApi.getStats().then(setStats).catch(console.error).finally(() => setLoading(false));
    }, []);

    const cards = [
        { label: 'Homepage', path: '/admin/homepage', icon: Home, color: 'bg-blue-500', desc: 'Hero, Benefícios, FAQ, Como Funciona, Footer' },
        { label: 'Quiz', path: '/admin/quiz', icon: HelpCircle, color: 'bg-green-500', desc: `${stats?.questions || '—'} perguntas • ${stats?.categories || '—'} categorias` },
        { label: 'Resultados', path: '/admin/results', icon: BarChart3, color: 'bg-purple-500', desc: 'Níveis, Insights, Faixas, Textos' },
        { label: 'Cursos', path: '/admin/courses', icon: BookOpen, color: 'bg-orange-500', desc: `${stats?.courses || '—'} cursos cadastrados` },
    ];

    return (
        <div>
            <h1 className="text-2xl font-bold mb-2">Dashboard</h1>
            <p className="text-gray-500 mb-6">Gerencie todo o conteúdo do portal Maturidade Digital.</p>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                {[
                    { label: 'Diagnósticos', value: stats?.diagnostics, icon: BarChart3, color: 'text-blue-600' },
                    { label: 'Usuários', value: stats?.users, icon: Users, color: 'text-green-600' },
                    { label: 'Perguntas', value: stats?.questions, icon: HelpCircle, color: 'text-purple-600' },
                    { label: 'Cursos', value: stats?.courses, icon: BookOpen, color: 'text-orange-600' },
                ].map(s => (
                    <div key={s.label} className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm">
                        <div className="flex items-center gap-2 mb-1">
                            <s.icon className={`h-4 w-4 ${s.color}`} />
                            <span className="text-xs text-gray-500 uppercase tracking-wider">{s.label}</span>
                        </div>
                        <p className="text-2xl font-bold text-gray-800">
                            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : (s.value ?? '—')}
                        </p>
                    </div>
                ))}
            </div>

            {/* Module Cards */}
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Módulos</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {cards.map(card => (
                    <Link key={card.path} to={card.path}
                        className="group bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden"
                    >
                        <div className={`${card.color} h-2`} />
                        <div className="p-5">
                            <div className="flex items-center gap-3 mb-2">
                                <card.icon className="h-6 w-6 text-gray-700" />
                                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-blue-600 transition-colors">{card.label}</h3>
                            </div>
                            <p className="text-sm text-gray-500">{card.desc}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
